import React, {useState} from 'react'
import API from './Api/API'
import Profile from './Profile/Profile'
import Webhook from './Webhook/Webhook'
 
const Account = () => {

  const [account, setAccount] = useState('1')

  function toggle() { 
    setAccount(prevState => '1')
  }
  function toggleApi() { 
    setAccount(prevState => '2')
  }
  function toggleWebhook() { 
    setAccount(prevState => '3')
  }

  return (
    <div className='inner__page'>
        { account === '1' ? <Profile toggle={toggle} toggleApi={toggleApi} toggleWebhook={toggleWebhook} /> : account === '2' ?
        <API  toggleApi={toggleApi} toggleWebhook={toggleWebhook} toggle={toggle} /> : 
        <Webhook toggleWebhook={toggleWebhook} toggle={toggle} toggleApi={toggleApi}/>}
    </div>
  )
}

export default Account